export default "__VITE_ASSET__d728qxfG__"